import { httpService } from '@/services/HttpService';

class VpnService {
  createVpnUser(workspaceId: number, regionId: number, username: string, email: string): Promise<any> {
    return httpService.post(`workspaces/${workspaceId}/regions/${regionId}/vpn_users`, { username, email });
  }
  getVpnUsers(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/vpn_users`);
  }
  deleteVpnUser(workspaceId: number, regionId: number, vpnUserUuid: number): Promise<any> {
    return httpService.delete(`workspaces/${workspaceId}/regions/${regionId}/vpn_users/${vpnUserUuid}`, '');
  }
  getVpnClientData(vpnUserUuid: string): Promise<any> {
    return httpService.get(`vpn_users/${vpnUserUuid}`);
  }
  downloadVpnClient(
    vpnUserUuid: string,
    password: string,
    os: string,
    isAuthErrorSuppressed: boolean = false
  ): Promise<any> {
    return httpService.postWithHeadersBinary(
      `vpn_users/${vpnUserUuid}/download_client`,
      { password, os },
      {},
      { isAuthErrorSuppressed }
    );
  }
}

export const vpnService = new VpnService();
